import { useNavigate } from "react-router-dom";
import { PlusCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isPwaMode } from "@/utils/pwaUtils";

interface PatientAddButtonProps {
  visible: boolean;
}

export function PatientAddButton({ visible }: PatientAddButtonProps) {
  const navigate = useNavigate();
  const isPwa = isPwaMode();
  
  if (!visible) return null;
  
  return (
    <Button 
      onClick={() => navigate("/patients/new")} 
      size="icon" 
      className={`fixed right-4 w-14 h-14 rounded-full shadow-lg z-40 ${isPwa ? 'patient-add-button-pwa' : 'bottom-24'}`}
    >
      <PlusCircle size={32} />
    </Button>
  );
}
